var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrongSurfaceWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 5.765,
    cy: 5.765,
    r: 5.765,
    transform: "translate(1.647 1.647)",
    fill: "#83cfdf"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 5.765,
    cy: 5.765,
    r: 5.765,
    transform: "translate(18.12 6.589)",
    fill: "#e16f47"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 5.765,
    cy: 5.765,
    r: 5.765,
    transform: "translate(13.178 18.12)",
    fill: "#e6f7fa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M1.292,210.583H4.521a1.292,1.292,0,0,0,0-2.583H1.292a1.292,1.292,0,0,0,0,2.583Z",
    transform: "translate(0 -191.208)",
    fill: "#1c3252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M134.208,64a7.113,7.113,0,0,0-7.1,7.1,1.292,1.292,0,0,0,2.583,0,4.521,4.521,0,1,1,4.521,4.521H121.292a1.292,1.292,0,1,0,0,2.583h8.4a4.521,4.521,0,1,1-4.521,4.521,1.292,1.292,0,0,0-2.583,0,7.1,7.1,0,1,0,12.551-4.553,1.294,1.294,0,0,0,.223-.069A7.1,7.1,0,0,0,134.208,64Z",
    transform: "translate(-110.312 -58.833)",
    fill: "#1c3252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M7.1,11.625H1.292a1.292,1.292,0,1,0,0,2.583H7.1A7.1,7.1,0,1,0,0,7.1a1.292,1.292,0,1,0,2.583,0A4.521,4.521,0,1,1,7.1,11.625Z",
    fill: "#1c3252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongSurfaceWind);
export default __webpack_public_path__ + "static/media/strongSurfaceWind.ccb5050b96ace7566a433a231073f31f.svg";
export { ForwardRef as ReactComponent };